/**
 * RFST — Password / landing page
 * Reveals the storefront password field on demand. The wordmark animation is
 * pure CSS so it plays even before this script loads.
 */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var toggle = document.querySelector('[data-password-toggle]');
  var panel = document.getElementById('PasswordEntry');
  if (!toggle || !panel) return;

  // If Shopify re-rendered the page after a wrong password, keep the field open.
  if (panel.querySelector('[role="alert"]')) {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  }

  toggle.addEventListener('click', function () {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;

    if (!isOpen) {
      var input = panel.querySelector('[data-password-input]');
      if (input) input.focus();
    }
  });
})();
